import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import JwtService from 'src/app/auth/services/jwtService';

const PdfRenderWithPath = ({ open, onClose, path }) => {
  const { t } = useTranslation('translations');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <DialogTitle
        style={{
          padding: '16px',
        }}
      >
        {t('AttachedFile')}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666',
          }}
        >
          <CloseIcon />
        </button>
      </DialogTitle>
      <DialogContent>
        {path && (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
              httpHeaders={{ Authorization: `Bearer ${JwtService.getAccessToken()}` }}
              fileUrl={`${process.env.REACT_APP_BASE_API_URL}/filems/Application/ViewApplicationFile?path=${path}`}
            />
          </Worker>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '16px' }}>
        <Button onClick={onClose} variant="outlined">
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PdfRenderWithPath;
